import View360 from '@egjs/react-view360';

export const PanoramaZoomButtons = ({ viewerRef }: { viewerRef: React.MutableRefObject<View360 | null> }) => {
  // 2) A helper that bumps zoom with clamping (works even if wheel/pinch zoom is disabled)
  const bumpZoom = (factor: number) => {
    const cam = viewerRef.current?.camera;
    if (!cam) return;

    // const { min, max } = cam.getZoomRange(); // v4 API
    const next = Math.max(0.5, Math.min(3, cam.zoom * factor));
    // Smooth change (use lookAt for instant)
    // console.log(factor, next, cam.zoom);
    console.log(factor, cam.zoom);
    void cam.animateTo({ zoom: next, duration: 200 });
  };

  // 3) Wire your buttons to this helper
  const zoomIn = () => bumpZoom(1.15);
  const zoomOut = () => bumpZoom(0.85);

  return (
    <>
      <button className="z-2 absolute bottom-2 right-2 text-white md:bottom-2" onClick={zoomIn}>
        +
      </button>
      <button className="z-2 absolute bottom-2 right-10 text-white md:bottom-2" onClick={zoomOut}>
        -
      </button>
    </>
  );
};
